(() => {

  const breakpoint = window.matchMedia('(max-width: 768px)');
  // const sliders = qsa('.js-featured-multiple-collections-swiper');
  const sliders = document.querySelectorAll('.js-featured-multiple-collections-swiper');

  const initSwiper = (
    init = false,
    slidesOffsetBefore = 100
  ) => {
    sliders && sliders.forEach((item, index) => {
      let i = index + 1;
      new Swiper(`.js-featured-multiple-collections-swiper-${i}`, {
        slidesPerView: 'auto',
        slidesOffsetBefore: slidesOffsetBefore,
        init: init,
        freeMode: true,
        navigation: {
          nextEl: `.js-featured-multiple-collections-button-next-${i}`,
          prevEl: `.js-featured-multiple-collections-button-prev-${i}`,
          clickable: true
        },
        pagination: {
          el: `.js-featured-multiple-collections-pagination-${i}`,
          type: 'bullets'
        }
      });
    })
  }

  const breakpointChecker = () => {
    if (breakpoint.matches) {
      initSwiper(true, 0);
    } else {
      initSwiper(true);
    }
  };

  const iconSwipers = qsa('.js-featured-multiple-collections__icons');

  const initIconSwiper = (init = true) => {
    iconSwipers && iconSwipers.forEach((iconSwiper) => {
      new Swiper(iconSwiper, {
        slidesPerView: 'auto',
        init: init,
        initialSlide: 0,
        freeMode: true,
        navigation: {
          nextEl: `.js-featured-multiple-collections__tab-next`,
          prevEl: `.js-featured-multiple-collections__tab-prev`,
          clickable: true
        },
      })
    })
  }
  
  // Function to handle tab switching
  function showTab(tabId) {
    // Hide all tab panels
    const tabPanels = document.querySelectorAll('.js-featured-multiple-collections__panel');
    tabPanels.forEach(panel => panel.style.display = 'none');

    // Show the selected tab panel
    
    const selectedTab = document.getElementById(tabId);
    selectedTab !== null ? selectedTab.style.display = 'block' : tabPanels[0].style.display = 'block'
  }

  // Event listener for tab buttons
  const tabButtons = document.querySelectorAll('.js-featured-multiple-collections__tab-link');
  tabButtons[0].classList.add('is-active');
  tabButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Get the data-tab attribute value to identify the target tab panel
      const targetTab = button.getAttribute('data-tab');
      
      tabButtons.forEach(item => {
        item.classList.remove('is-active');
      })
      button.classList.add('is-active');
      showTab(targetTab);
    });
  });

  
  breakpoint.addEventListener('change', breakpointChecker);
  document.addEventListener("shopify:section:load", breakpointChecker);
  breakpointChecker();
  initIconSwiper();
  showTab('id');
})();
